import React, { FC } from 'react';

import { Box } from '@mui/material';
import { styled } from '@mui/material';
import { alpha } from '@mui/material/styles';

import IKImage from '~/components/IKImage/IKImage';
import { HERO_IMG_SRC_SET } from '~/const';

interface ImageBackgroundProps {
  preview: string;
  hasSubscription: boolean;
  title?: string;
}

const ImageBackground: FC<ImageBackgroundProps> = ({ preview, title, hasSubscription }) => {
  return (
    <ImgWrapper hasSubscription={hasSubscription}>
      <FadeInImage
        data-testid="imageBackground"
        path={preview}
        alt={title}
        srcset={HERO_IMG_SRC_SET}
        sizes="100vw"
        draggable={false}
      />
      <TopGradient />
    </ImgWrapper>
  );
};

export default ImageBackground;

const FadeInImage = styled(IKImage)`
  transition: 0.6s;
  opacity: ${({ path, theme }) =>
    !!path ? (theme.isSsku ? (theme.palette.mode === 'light' ? 0.05 : 0.1) : 1) : 0};
  height: 100%;
  width: 100%;
  object-fit: cover;
`;
const ImgWrapper = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'hasSubscription',
})<{ hasSubscription: boolean }>`
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 650px;

  ${({ theme }) => theme.breakpoints.up('md')} {
    height: calc(100vh - 40px);
  }

  &::before {
    content: '';
    display: block;
    position: absolute;
    width: 100%;
    left: 0;
    top: 0;
    height: 100%;
    visibility: ${({ theme }) =>
      theme.isSsku && theme.palette.mode === 'light' ? 'hidden' : 'visible'};
    background: linear-gradient(
        90deg,
        ${({ theme }) => theme.palette.common.blockBackground.main} 0%,
        ${({ theme }) => alpha(theme.palette.common.blockBackground.main, 0.67)}
          ${({ hasSubscription }) => (hasSubscription ? 50 : 60)}%,
        ${({ theme }) => alpha(theme.palette.common.blockBackground.main, 0)} 100%
      )
      0% 0% no-repeat;
    z-index: 0;

    ${({ theme }) => theme.breakpoints.down('md')} {
      background: ${({ theme }) => alpha(theme.palette.common.blockBackground.main, 0.698039)};
    }
  }

  &::after {
    content: '';
    display: block;
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 373px;
    visibility: ${({ theme }) =>
      theme.isSsku && theme.palette.mode === 'light' ? 'hidden' : 'visible'};
    background: linear-gradient(
      0deg,
      ${({ theme }) => theme.palette.common.blockBackground.main} 0%,
      ${({ theme }) => alpha(theme.palette.common.blockBackground.main, 0.0001)} 100%
    );
    z-index: 0;
  }
`;
const TopGradient = styled(Box)`
  width: 100%;
  height: 107px;
  position: absolute;
  left: 0;
  top: 0;
  background: linear-gradient(
    180deg,
    ${({ theme }) => theme.palette.common.blueDark} 0%,
    ${({ theme }) => alpha(theme.palette.common.blueDark, 0.0001)} 100%
  );
  -webkit-background-origin: padding-box;
  -o-background-origin: padding-box;
  -moz-background-origin: padding;
  z-index: 0;
`;
